"use strict";

var _typeof = require("@babel/runtime/helpers/typeof");
var e = require("../slicedToArray-a539bf82.js"),
  t = require("react"),
  n = require("prop-types"),
  a = require("classnames"),
  r = require("lodash/throttle"),
  i = require("../grid-965d799c.js"),
  l = require("../taggedTemplateLiteral-97b463ad.js"),
  o = require("styled-components"),
  d = require("polished/lib/helpers/rem"),
  u = require("../typography-fb2881fe.js");
function s(e) {
  return e && "object" == _typeof(e) && "default" in e ? e : {
    "default": e
  };
}
require("../_commonjsHelpers-f10b257f.js"), require("../extends-fa579b0f.js"), require("../objectWithoutProperties-2581b642.js"), require("../defineProperty-b53f90b9.js"), require("../toPropertyKey-ec4a2a72.js"), require("../gradients-74ddcb08.js"), require("polished/lib/color/shade"), require("../colors-c0f39aa2.js");
var c,
  g,
  m,
  f,
  p,
  h,
  b,
  y,
  v,
  T,
  k,
  w,
  L,
  x,
  _,
  q,
  E,
  j,
  O,
  C,
  U,
  I,
  D,
  P,
  z,
  F,
  N,
  R,
  V = s(t),
  A = s(n),
  B = s(a),
  W = s(r),
  S = s(o),
  $ = s(d),
  H = S["default"].button(c || (c = l._taggedTemplateLiteral(["\n  ", "\n"])), function (e) {
    var t = e.theme,
      n = t.custom1070up(),
      a = t.mediumUp(),
      r = 0;
    return n && (r = $["default"](-32)), a || (r = 0), o.css(g || (g = l._taggedTemplateLiteral(["\n      position: absolute;\n      width: ", ";\n      height: ", ";\n      right: 0;\n      margin-right: ", ";\n      margin-top: ", ";\n      background: ", ";\n      border: none;\n      text-indent: ", ";\n      cursor: pointer;\n      ::before,\n      ::after {\n        content: '';\n        width: ", ";\n        height: ", ";\n        background-color: ", ";\n        transform: rotate(45deg) translateX(0);\n        position: absolute;\n        left: 50%;\n        top: 0;\n      }\n      ::before {\n        transform: rotate(-45deg) translateX(0);\n      }\n      :hover::before,\n      :hover::after {\n        background-color: ", ";\n      }\n    "])), $["default"](32), $["default"](32), r, a ? 0 : $["default"](-32), t.colors.neutral.grayDark10, $["default"](-9999), $["default"](2), $["default"](32), t.colors.neutral.white, t.colors.action.lightTheme.utilityItemHover);
  }),
  X = S["default"].button(m || (m = l._taggedTemplateLiteral(["\n  ", "\n"])), function (e) {
    var t = e.env,
      n = e.theme,
      a = t.basePath,
      r = t.nmxTemplateVersion;
    return o.css(f || (f = l._taggedTemplateLiteral(["\n      display: block;\n      width: ", ";\n      height: ", ";\n      margin-right: ", ";\n      padding: 0;\n      color: ", "; /** only used to not flag automated ADA testing */\n      background: none;\n      border: none;\n      line-height: 0;\n      text-indent: ", ";\n      cursor: pointer;\n      &::after {\n        content: '';\n        display: block;\n        width: ", ";\n        height: ", ";\n        margin-right: ", ";\n        background-image: url('", "/template/assets/", "/images/icons/utility/play-media.svg');\n        filter: invert(100%) sepia(0%) saturate(7500%) hue-rotate(321deg) brightness(110%) contrast(101%); /** color to #FFFFFF $color-neutral-white */\n        background-size: cover;\n        background-repeat: no-repeat;\n      }\n      &:hover,\n      &:focus {\n        &::after {\n          filter: invert(31%) sepia(46%) saturate(2090%) hue-rotate(184deg) brightness(89%) contrast(89%); /** color to #1566aa ($blue-link) // TODO: convert to $color-system-cta-active-blue */\n        }\n      }\n    "])), $["default"](64), $["default"](64), $["default"](24), n.colors.neutral.white, $["default"](-9999), $["default"](64), $["default"](64), $["default"](16), a, r);
  }),
  K = S["default"](i.Col)(p || (p = l._taggedTemplateLiteral(["\n  ", "\n"])), function (e) {
    var t = e.theme,
      n = e.isOpen,
      a = t.mediumUp(),
      r = "block";
    return n && !a && (r = "flex"), o.css(h || (h = l._taggedTemplateLiteral(["\n      display: ", ";\n      padding: ", ";\n    "])), r, a ? "0 ".concat($["default"](16)) : 0);
  }),
  M = S["default"](i.Container)(b || (b = l._taggedTemplateLiteral(["\n  ", ""])), function (e) {
    var t = e.theme.mediumUp();
    return o.css(y || (y = l._taggedTemplateLiteral(["\n      padding: ", ";\n    "])), t ? "0 ".concat($["default"](16)) : 0);
  }),
  G = S["default"].div(v || (v = l._taggedTemplateLiteral(["\n  ", "\n"])), function (e) {
    var t = e.theme,
      n = e.backgroundImage,
      a = e.backgroundImageWebp,
      r = e.isOpen,
      i = t.mediumUp();
    return o.css(T || (T = l._taggedTemplateLiteral(["\n      position: absolute;\n      top: 0;\n      left: 0;\n      width: 100%;\n      height: ", ";\n      min-height: ", ";\n      margin-top: ", ";\n      background-color: ", ";\n      background-image: url(", ");\n      background-image: url(", ");\n      background-size: ", ";\n      background-position-x: ", ";\n      background-position-y: 0;\n    "])), i ? "100%" : $["default"](320), i ? $["default"](320) : "unset", i ? 0 : $["default"](160), r ? t.colors.neutral.black : t.colors.neutral.grayDark10, r ? "none" : n, r ? "none" : a || n, r ? "unset" : "cover", i ? "50%" : "100%");
  }),
  J = S["default"].div(k || (k = l._taggedTemplateLiteral(["\n  ", "\n"])), function (e) {
    var t = e.theme.mediumUp();
    return o.css(w || (w = l._taggedTemplateLiteral(["\n      display: flex;\n      position: ", ";\n      width: ", ";\n      top: ", ";\n      left: ", ";\n      align-items: center;\n      justify-content: ", ";\n    "])), t ? "relative" : "absolute", t ? "auto" : "100%", t ? 0 : $["default"](288), t ? "unset" : 0, t ? "normal" : "center");
  }),
  Q = S["default"].div(L || (L = l._taggedTemplateLiteral(["\n  /** TODO: use thes video styles in stand-alone Video Component, .video-container can be a default/global Video Component style */\n  position: relative;\n  height: 0;\n  padding-bottom: 56.25%;\n  iframe {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n  }\n"]))),
  Y = S["default"](i.Row)(x || (x = l._taggedTemplateLiteral(["\n  ", "\n"])), function (e) {
    var t = e.theme,
      n = e.isOpen,
      a = t.mediumUp(),
      r = "hidden";
    return n && !a && (r = "visible"), o.css(_ || (_ = l._taggedTemplateLiteral(["\n      width: 100%;\n      height: ", ";\n      max-height: 100%;\n      margin-top: ", ";\n      overflow-y: ", ";\n      justify-content: ", ";\n      align-items: center;\n    "])), a ? $["default"](530) : $["default"](160), a ? 0 : $["default"](-320), r, n ? "normal" : "space-evenly");
  }),
  Z = S["default"].section(q || (q = l._taggedTemplateLiteral(["\n  && {\n    ", "\n  }\n"])), function (e) {
    var t = e.theme,
      n = e.isOpen,
      a = t.largeUp(),
      r = t.mediumUp(),
      i = 0,
      d = $["default"](480),
      u = "flex",
      s = "unset",
      c = $["default"](320),
      g = t.colors.neutral.grayLight30,
      m = $["default"](160),
      f = "auto";
    return r && (u = "block", s = $["default"](993.78), c = d, g = t.colors.neutral.grayDark1, m = "auto", f = "0 auto"), r && !n && (i = "0 ".concat($["default"](60))), a ? d = $["default"](530) : r && (d = $["default"](350)), o.css(E || (E = l._taggedTemplateLiteral(["\n      display: flex;\n      position: relative;\n      height: ", ";\n      margin-bottom: 0;\n      padding: ", ";\n      background-color: ", ";\n      justify-content: center;\n      overflow: hidden;\n      > .nmx-container {\n        display: ", ";\n        height: ", ";\n        max-width: unset;\n        max-height: 100%;\n        margin: ", ";\n        align-items: center;\n        z-index: 1;\n        > .nmx-row {\n          .video-container {\n            display: ", ";\n            position: ", ";\n            left: ", ";\n            top: 0;\n            width: ", ";\n            max-width: ", ";\n            max-height: ", ";\n            margin: ", ";\n            iframe {\n              max-width: ", ";\n              max-height: ", ";\n            }\n          }\n        }\n      }\n      sup {\n        font-size: 65%; /** TODO: make this a global change? default is currently set to 75%? */\n      }\n    "])), d, i, g, u, m, f, u, r ? "relative" : "absolute", r ? 0 : "unset", r ? "auto" : "100%", s, c, r ? "0 auto" : "".concat($["default"](160), " auto 0"), s, r ? d : $["default"](320));
  }),
  ee = S["default"](u.TypographyComponent)(j || (j = l._taggedTemplateLiteral(["\n  ", ""])), function (e) {
    var t = e.theme,
      n = t.mediumUp();
    return o.css(O || (O = l._taggedTemplateLiteral(["\n      display: ", ";\n      padding-bottom: ", ";\n      font-size: ", ";\n      line-height: ", ";\n      font-weight: 300;\n      text-transform: uppercase;\n      letter-spacing: ", ";\n      color: ", ";\n    "])), n ? "block" : "none", $["default"](24), $["default"](14), $["default"](20), $["default"](2), t.colors.neutral.white);
  }),
  te = S["default"](u.TypographyComponent)(C || (C = l._taggedTemplateLiteral(["\n  ", "\n"])), function (e) {
    var t = e.theme.mediumUp();
    return o.css(U || (U = l._taggedTemplateLiteral(["\n    display: ", ";\n    padding: ", ";\n    text-align: center;\n    font-weight: 500;\n  "])), t ? "none" : "block", t ? 0 : "0 ".concat($["default"](16)));
  }),
  ne = S["default"](u.TypographyComponent)(I || (I = l._taggedTemplateLiteral(["\n  ", "\n"])), function (e) {
    var t,
      n = e.theme,
      a = n.largeUp(),
      r = n.mediumUp();
    return a ? t = $["default"](16) : r && (t = $["default"](12)), o.css(D || (D = l._taggedTemplateLiteral(["\n      display: ", ";\n      color: ", ";\n      font-weight: 500;\n      ", "\n    "])), r ? "block" : "none", n.colors.neutral.white, t && o.css(P || (P = l._taggedTemplateLiteral(["\n          font-size: ", ";\n        "])), t));
  }),
  ae = S["default"](u.TypographyComponent)(z || (z = l._taggedTemplateLiteral(["\n  ", "\n"])), function (e) {
    var t,
      n,
      a = e.theme,
      r = a.mediumUp();
    return a.largeUp() ? (t = $["default"](44), n = $["default"](52)) : r && (t = $["default"](32), n = $["default"](43)), o.css(F || (F = l._taggedTemplateLiteral(["\n      padding-bottom: ", ";\n      color: ", ";\n      ", "\n      ", "\n      text-align: ", ";\n    "])), r ? $["default"](32) : 0, r ? a.colors.neutral.white : a.colors.neutral.grayDark20, t && o.css(N || (N = l._taggedTemplateLiteral(["\n          font-size: ", ";\n        "])), t), n && o.css(R || (R = l._taggedTemplateLiteral(["\n          line-height: ", ";\n        "])), n), r ? "left" : "center");
  }),
  re = function re(n) {
    var a = n.backgroundImage,
      r = n.backgroundImageWebp,
      l = n.className,
      o = n.config,
      d = n.duration,
      u = n.durationDisplay,
      s = n.playButtonSupportiveText,
      c = n.sectionId,
      g = n.title,
      m = n.videoId,
      f = n.videoTitle,
      p = t.useState(!1),
      h = e._slicedToArray(p, 2),
      b = h[0],
      y = h[1],
      v = function v() {
        y(!b);
      };
    return t.useEffect(function () {
      function e(e) {
        27 === e.keyCode && b && v();
      }
      if ("undefined" != typeof document) return window.addEventListener("keydown", W["default"](e, 100)), function () {
        window.removeEventListener("keydown", W["default"](e, 100));
      };
    }, [b]), V["default"].createElement(Z, {
      id: "".concat(c, "-section-container"),
      className: B["default"]("nmx-section-video", {
        "nmx-nested": b
      }, l),
      isOpen: b,
      "data-module": "".concat(c, "-section-container:video-module:A")
    }, V["default"].createElement(G, {
      id: "".concat(c, "-bg-container"),
      className: "lazy",
      dataBg: a,
      backgroundImage: a,
      backgroundImageWebp: r,
      isOpen: b
    }), !b && V["default"].createElement(i.Container, null, V["default"].createElement(Y, {
      isOpen: b
    }, V["default"].createElement(i.Col, {
      medium: 8
    }, d && V["default"].createElement(ee, {
      component: "time",
      dateTime: d
    }, u), V["default"].createElement(ae, {
      component: "h2"
    }, g), V["default"].createElement(J, null, V["default"].createElement(X, {
      env: o,
      onClick: function onClick() {
        v();
      }
    }, "Play Media"), V["default"].createElement(ne, {
      disableBottomPadding: !0
    }, s))))), b && V["default"].createElement(M, null, V["default"].createElement(Y, {
      isOpen: b
    }, V["default"].createElement(K, {
      align: "center",
      isOpen: b
    }, V["default"].createElement(te, {
      component: "h2"
    }, g), V["default"].createElement(Q, {
      className: "video-container",
      "data-video-id": m
    }, V["default"].createElement("iframe", {
      width: "600",
      height: "320",
      title: f,
      src: "https://www.youtube.com/embed/".concat(m, "?enablejsapi=1&autoplay=1"),
      frameBorder: "0",
      allow: "accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture;enablejsapi;",
      allowFullScreen: ""
    }), V["default"].createElement(H, {
      id: "close-video-button-".concat(m),
      onClick: function onClick() {
        v();
      }
    }, "Close media player"))))));
  };
re.propTypes = {
  backgroundImage: A["default"].any.isRequired,
  backgroundImageWebp: A["default"].any,
  className: A["default"].string,
  config: A["default"].shape({
    basePath: A["default"].string,
    nmxTemplateVersion: A["default"].string
  }),
  playButtonSupportiveText: A["default"].string,
  duration: A["default"].string,
  durationDisplay: A["default"].string,
  sectionId: A["default"].string.isRequired,
  title: A["default"].any.isRequired,
  variant: A["default"].oneOf(["inline", "modal"]),
  videoId: A["default"].string.isRequired,
  videoTitle: A["default"].string.isRequired
}, re.defaultProps = {
  className: null,
  config: {
    basePath: "https://www.northwesternmutual.com",
    nmxTemplateVersion: "3.10.16"
  },
  variant: "inline"
}, module.exports = re;